module.exports = __webpack_public_path__ + "img/Youtube.5cadbe57.png";